export default function adaptiveSize(resolutionUnit, relativeValue) {
    let baseSize;
    switch (resolutionUnit) {
        case ResolutionUtils.UHD_8K:
            baseSize = 70
            break
        case ResolutionUtils.UHD_4K:
            baseSize = 62;
            break;
        case ResolutionUtils.QHD:
            baseSize = 48;
            break;
        case ResolutionUtils.FULL_HD:
            baseSize = 20;
            break;
        case ResolutionUtils.HD:
        case ResolutionUtils.XGA:
        default:
            baseSize = 16;
            break;
    }

    return baseSize * relativeValue;
}

export function getWindowSize() {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    }
}

export function getActualResolutionCategory(screenSize) {
    const maxDimension = Math.max(screenSize.width, screenSize.height);

    return ResolutionUtils.unitBySize(maxDimension);
}

export const ResolutionUtils = {
    SD: 'SD / Low',
    XGA: 'XGA',
    HD: 'HD / 720p',
    FULL_HD: 'Full HD / 1080p',
    QHD: 'QHD / 1440p',
    UHD_4K: '4K UHD',
    UHD_8K: '8K',

    get categories() {
        return [
            this.SD,
            this.XGA,
            this.HD,
            this.FULL_HD,
            this.QHD,
            this.UHD_4K,
            this.UHD_8K,
        ];
    },

    unitBySize(size) {
        const categories = this.categories;
        return categories.find(
            (category) => {
                return size <= ResolutionUtils.getMaxDimension(category);
            }
        ) || this.UHD_8K;
    },

    getMaxDimension(category) {
        switch (category) {
            case this.XGA:
                return 1024;
            case this.HD:
                return 1280;
            case this.FULL_HD:
                return 1920;
            case this.QHD:
                return 2560;
            case this.UHD_4K:
                return 3840;
            case this.UHD_8K:
                return 7680;
            case this.SD:
            default:
                return 800;
        }
    },
};